(function(window, $) {
	if ( $(window).width() >= 768 ) {
		var stickyOffsetTop = $('.sticky').offset().top,
			stickyPositionTop = $('.sticky').position().top,
			stickyLimit = $('.stickyContainer').offset().top + $('.stickyContainer').outerHeight() - $('.sticky').outerHeight(),
			anticipatedTop = 0;

		window.addEventListener('scroll', function(e) {
			var y = window.scrollY || document.documentElement.scrollTop;

			if ( $(window).width() < 1280 ) {
				anticipatedTop = $('.header').outerHeight() + 20;
			}

			if ( y >= (stickyOffsetTop - anticipatedTop) && y <= (stickyLimit - anticipatedTop) ) {
				$('.sticky').css('top', stickyPositionTop + y - stickyOffsetTop + anticipatedTop);
			}
		});
	}
})(window, jQuery);
